module.exports = __webpack_public_path__ + "img/block4.34350658.webp";